import { render } from "./App.vue?vue&type=template&id=3fea81ac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3fea81ac&lang=css"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__